// HomeLeaderboard.js
import { connect } from 'react-redux';

import { MERGE_OPERATION_DATA } from '../ActionTypes.js';
import {
  LEADERBOARD_CATEGORIES,
  PUBLIC_LEADERBOARD_URL_PATH,
} from '../RemoteConfigKeys.js';

import getOperationData from '../selector/getOperationData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getMeData from '../selector/getMeData.js';
import HomeLeaderboard from '../component/HomeLeaderboard.jsx';

const mapStateToProps = (state, { region }) => {
  const activeCategory = getOperationData(state, ['leaderboard'], 'category');
  const categories = getRemoteConfigData(state, LEADERBOARD_CATEGORIES);
  const publicLeaderboardUrlPath = getRemoteConfigData(
    state,
    PUBLIC_LEADERBOARD_URL_PATH
  );
  const regionGroup = getMeData(state, 'regionGroup');

  return {
    categories,
    activeCategory: activeCategory || categories[0],
    region: region || regionGroup, // fallback to region group
    publicLeaderboardUrlPath,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    changeCategory: ({ category }) =>
      dispatch({
        type: MERGE_OPERATION_DATA,
        payload: {
          selectPath: ['leaderboard'],
          data: {
            category,
          },
        },
      }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  // equals to `{ ...ownProps, ...stateProps, ...dispatchProps }`
  // ref: https://github.com/reduxjs/react-redux/blob/v7.1.0/src/connect/mergeProps.js
  null,
  { forwardRef: true }
)(HomeLeaderboard);
